import { type ReactNode } from "react";
import { clsx } from "clsx";

interface CardProps {
  title?: string;
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: "none" | "sm" | "md" | "lg";
}

const paddingClasses = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

export function Card({ title, children, className, hover = false, padding = "md" }: CardProps) {
  return (
    <div
      className={clsx(
        "bg-white rounded-xl border border-[#e2e8f0]",
        "shadow-[0_1px_3px_0_rgb(0_0_0/0.07),0_1px_2px_-1px_rgb(0_0_0/0.07)]",
        hover && "transition-shadow hover:shadow-[0_4px_16px_0_rgb(0_0_0/0.12)] cursor-pointer",
        paddingClasses[padding],
        className,
      )}
    >
      {title && (
        <h3 className="text-base font-semibold text-[#0f172a] mb-4">{title}</h3>
      )}
      {children}
    </div>
  );
}
